/* eslint-disable new-cap */
<template>
  <div class="add-new-custom-query-wrapper" ref="addNewCustomQueryPageEle">
    <input type="text" class="heading-page" v-model="innerCustomQuery.name" aria-label="Query X" placeholder="Click to add name" />
    <div class="save-date" v-if="innerCustomQuery.updatedAt">
      <CloudFilled /> Saved {{convertToDateTime(innerCustomQuery.updatedAt)}}
    </div>
    <textarea rows="1" class="custom-description" placeholder="Click to add description" v-model="innerCustomQuery.description"></textarea>
    <div class="api-slug-wrapper mb-3">
        <span class="label">Public API:</span>
        <Switch
          class="toggle-method"
          v-model:checked="innerCustomQuery.public"
        />
        <div class="input-group url-custom-query">
          <span class="input-group-text" id="basic-addon1">GET</span>
          <input
            type="text"
            class="form-control"
            placeholder="Url will show when you save custom query"
            aria-label="Username"
            aria-describedby="basic-addon1"
            :value="getURLDataQuery"
            disabled
          >
        </div>
    </div>
    <Editor v-model="innerCustomQuery.query" language="sql" class="mb-3" :runCallback="onClickPreviewQuery" />
    <div class="btn-action-wrapper mb-3">
      <Button class="white btn-run" @click="onClickPreviewQuery" :dynamicAttrs="{loading: loadingPreview}">
        <CaretRightFilled /> Run
      </Button>
      <Button class="btn-save" @click="onClickSaveQuery" :dynamicAttrs="{disabled: innerCustomQuery.query === '' || innerCustomQuery.name === ''}">
        Save
      </Button>
    </div>
    <div class="query-status mb-3">
      <div v-if="previewData && !loadingPreview">
        <CheckCircleFilled /> <span class="status">Query succeeded</span> <span class="time">at {{convertToDateTime(Date.now())}}</span>
      </div>
      <div v-if="errorMessagePreview">
        <ExclamationCircleOutlined /> <span class="status">Run failed</span>
      </div>
      <a-dropdown v-if="previewData && !loadingPreview" :trigger="['click']" overlayClassName="export-list-action">
        <!-- <a class="ant-dropdown-link btn-export-custom-query" @click.prevent>
          Export
          <DownOutlined />
        </a> -->
        <Button class="white btn-export-custom-query" @click.prevent :dynamicAttrs="{loading: loadingExportCustomQuery}">
          Export <DownOutlined />
        </Button>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a href="javascript:;" @click="toggleModalExportCustomQuery">Google Sheet</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="exportCustomQueryToCSV">CSV</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;">XLSX</a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <div class="error-result" v-if="errorMessagePreview">
      {{ errorMessagePreview }}
    </div>
    <!-- <pre>
      {{innerCustomQuery}}
    </pre> -->
    <TableExcel v-model="tableData" :columns="tableColumn" v-if="tableData && tableColumn && !loadingPreview"/>
    <ErrorMessage v-if="errorPreview" :messsage="errorPreview" />
    <a-modal v-model:visible="isShowModalExportCustomQuery">
      <div class="content-export-customer-query-wrapper">
        <div class="info-wapper">
          <div class="title">
            Export Query’s result to Google Spreadsheet
          </div>
          <div class="description">
            If the sheet’s name does not exist, new sheet will be created. All the old content if exist will be overrided.
          </div>
          <InfoCircleOutlined />
        </div>
        <form class="custom-form">
          <div class="mb-3">
            <label for="google-spreadsheet-url" class="col-form-label">Google Spreadsheet URL</label>
            <input type="text" name="google-spreadsheet-url" v-model="exportGoogleSpreadSheet.url"
            class="form-control" id="google-spreadsheet-url" placeholder="https://docs.google.com....">
          </div>
          <div class="mb-3">
            <label for="google-spreadsheet-name" class="col-form-label">Sheet’s name</label>
            <input type="text" name="google-spreadsheet-name" v-model="exportGoogleSpreadSheet.sheetName" class="form-control"
            id="google-spreadsheet-name">
          </div>
          <div class="mb-3">
            <label for="google-spreadsheet-name" class="mr-15">Mode:</label>
            <Select style="width: 90px" v-model:value="exportGoogleSpreadSheet.mode">
              <SelectOption value="full">Full</SelectOption>
              <SelectOption value="append">Append</SelectOption>
            </Select>
          </div>
        </form>
        <div class="error-result" v-if="errorMessageExportCustomQuery">
          {{ errorMessageExportCustomQuery }}
        </div>
      </div>
      <template #footer>
        <Button :dynamicAttrs="{class: 'btn-export', loading: loadingExportCustomQuery, disabled: !exportGoogleSpreadSheet.url || !exportGoogleSpreadSheet.sheetName}" @click="exportCustomQueryToGoogleSheet">Export</Button>
      </template>
    </a-modal>
  </div>
</template>

<script type="ts">
/* eslint-disable no-restricted-syntax */
/* eslint-disable radix */

import {
  defineComponent, ref, computed,
} from 'vue';
import get from 'lodash/fp/get';
import isEmpty from 'lodash/fp/isEmpty';
import startsWith from 'lodash/fp/startsWith';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import isNil from 'lodash/fp/isNil';
import moment from 'moment';

import Menu from '@/components/Menu/template.vue';
import TableExcel from '@/components/TableExcel/template.vue';
import Dropdown from '@/components/Dropdown/template.vue';
import Editor from '@/components/Editor/Editor.vue';
import Switch from '@/components/Switch/template.vue';
import Select, { SelectOption } from '@/components/Select/template.vue';
import Button from '@/components/Button/template.vue';
import Table from '@/components/Table/template.vue';
import Modal from '@/components/Modal/template.vue';
import ErrorMessage from '@/components/ErrorMessage/template.vue';
import CloudFilled from '@ant-design/icons-vue/CloudFilled';
import DownOutlined from '@ant-design/icons-vue/DownOutlined';
import CaretRightFilled from '@ant-design/icons-vue/CaretRightFilled';
import CheckOutlined from '@ant-design/icons-vue/CheckOutlined';
import InfoCircleOutlined from '@ant-design/icons-vue/InfoCircleOutlined';
import CloudUploadOutlined from '@ant-design/icons-vue/CloudUploadOutlined';
import ExclamationCircleOutlined from '@ant-design/icons-vue/ExclamationCircleOutlined';
import CheckCircleFilled from '@ant-design/icons-vue/CheckCircleFilled';
import { generateColumnTableExcel } from '@/utils/query';
import { getSpreadsheetId } from '@/utils/string';
import usePreviewQuery from '../../composables/usePreviewQuery';
import useExportCustomQuery from '../../composables/useExportCustomQuery';
import CustomQuery from '../../models/CustomQuery';
import { message } from 'ant-design-vue';

import './styles.scss';

export default defineComponent({
  name: 'FormCustomQuery',
  components: {
    Button,
    Switch,
    Table,
    Dropdown,
    Menu,
    DownOutlined,
    CloudFilled,
    CheckOutlined,
    ErrorMessage,
    Editor,
    CaretRightFilled,
    CheckCircleFilled,
    ExclamationCircleOutlined,
    TableExcel,
    CloudUploadOutlined,
    Modal,
    InfoCircleOutlined,
    Select,
    SelectOption,
  },
  props: {
    customQuery: {
      type: CustomQuery,
    },
    loadingSave: {
      type: Boolean,
    },
    errorMessageSave: {
      type: String,
    },
    saveCustomQuery: {
      type: Function,
    },
  },
  setup() {
    const {
      loadingPreview,
      errorMessagePreview,
      fetchPreviewData,
      previewData,
      previewColumns,
    } = usePreviewQuery();

    const {
      loadingExportCustomQuery,
      errorMessageExportCustomQuery,
      exportCustomQueryDataToSpreadSheet,
      exportCutomQueryData,
    } = useExportCustomQuery();

    const addNewCustomQueryPageEle = ref(null);
    const widthPageCustomQuery = computed(() => addNewCustomQueryPageEle.value.clientWidth - 55);
    const bestQuantityColumn = computed(() => parseInt(widthPageCustomQuery.value / 200));
    const tableData = computed(() => {
      if (isEmpty(previewData.value)) return null;
      return previewData.value;
    });


    const tableColumn = computed(() => {
      if (isEmpty(previewColumns.value)) return null;

      const column = [];
      const previewColumnsValue = get('value', previewColumns);

      // Generate column object
      previewColumnsValue.forEach(element => {
        column.push(generateColumnTableExcel({
          key: element,
          value: element,
        }));
      });

      // Calculate column width
      const columnQuantity = get('length', filter((item) => !startsWith('_', item.name), column));
      if (columnQuantity > bestQuantityColumn.value) {
        return map((item) => {
          item.width = widthPageCustomQuery.value / columnQuantity;
          return item;
        }, column);
      }

      return column;
    });

    return {
      loadingPreview,
      errorMessagePreview,
      fetchPreviewData,
      previewData,
      widthPageCustomQuery,
      addNewCustomQueryPageEle,
      tableData,
      tableColumn,
      loadingExportCustomQuery,
      errorMessageExportCustomQuery,
      exportCustomQueryDataToSpreadSheet,
      exportCutomQueryData,
    };
  },
  data() {
    return {
      innerCustomQuery: this.customQuery ? { ...this.customQuery } : {
        query: '',
        name: '',
        description: '',
        public: false,
      },
      loading: false,
      loadingCreate: false,
      errorPreview: null,
      errorCreate: null,
      isShowModalExportCustomQuery: false,
      exportGoogleSpreadSheet: {
        url: '',
        sheetName: '',
        mode: 'full',
      }
    };
  },
  watch: {
    customQuery() {
      this.innerCustomQuery = this.customQuery;
    },
    'innerCustomQuery.public': {
      handler(newValue, oldValue) {
        console.log({
          newValue,
          oldValue,
        });
        if(this.innerCustomQuery.id && newValue !== oldValue) {
          this.saveCustomQuery(this.innerCustomQuery);
        }
      },
    },
    '$route.params.customQueryId': function () {
      this.errorPreview = null;
      this.errorCreate = null;
      this.loading = false;
      this.loadingCreate = false;
      this.previewData = null;
    },
  },
  computed: {
    getURLDataQuery() {
      const BE_API_URL = process.env.VUE_APP_API_BASE_URL;
      if (!isNil(this.innerCustomQuery.id)) return `${BE_API_URL}/${this.$route.params.slug}/cq/${this.innerCustomQuery.id}`;
      return '';
    },
  },
  methods: {
    convertToDateTime(date) {
      return moment(date).format('YYYY/MMM/DD, h:mm:ssa')
    },
    onClickPreviewQuery() {
      this.fetchPreviewData({ query: this.innerCustomQuery.query });
    },
    async onClickSaveQuery() {
      this.innerCustomQuery = await this.saveCustomQuery(this.innerCustomQuery);
      this.$router.push(`/projects/${this.$route.params.slug}/custom-query/${this.innerCustomQuery.id}`);
    },
    toggleModalExportCustomQuery() {
      this.isShowModalExportCustomQuery = !this.isShowModalExportCustomQuery;
    },
    async exportCustomQueryToGoogleSheet() {
      const spreadsheetId = getSpreadsheetId(this.exportGoogleSpreadSheet.url);
      if (!spreadsheetId) return;
      const { error } = await this.exportCustomQueryDataToSpreadSheet({
        spreadsheetId,
        sheetName: this.exportGoogleSpreadSheet.sheetName,
        mode: this.exportGoogleSpreadSheet.mode,
      });
      if (!error) {
        this.isShowModalExportCustomQuery = false;
        this.exportGoogleSpreadSheet = {
          sheetName: '',
          url: '',
          mode: 'full',
        };
        message.success('Export custom query successfully');
      }
    },
    async exportCustomQueryToCSV() {
      console.log('dzo dzo dzo');
      const { data, error } = await this.exportCustomQueryDataToSpreadSheet({
        localFile: 'csv'
      });
      if (!error) {
        console.log('exportCustomQueryToCSV', data);

        // Auto download file
        const csvContent = "data:text/csv;charset=utf-8," + data;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${this.innerCustomQuery.name}.csv`);
        document.body.appendChild(link); // Required for FF
        link.click();

        // Show success message
        message.success('Export custom query successfully');
      }
    },
  },
});
</script>
